<script setup lang="ts">
import UIKit from '@pocketprep/ui-kit'

const {
    Button: PocketButton,
    ModalContainer,
    Modal,
} = UIKit

type TStudentsCompleted = {
    studentsCompletedCount: number
    studentsNotCompletedCount: number
}

defineProps<{
    assignmentStudentCompletedStats: TStudentsCompleted
}>()

const emit = defineEmits<{
    'close': []
    'delete': []
}>()

</script>

<template>
    <Portal to="modal">
        <ModalContainer class="delete-assignment" @close="emit('close')">
            <Modal
                class="delete-assignment__modal"
                :showCloseButton="true"
                @close="emit('close')"
            >
                <div class="delete-assignment__modal-container">
                    <div class="delete-assignment__modal-head">Delete Assignment?</div>
                    <div
                        v-if="assignmentStudentCompletedStats && assignmentStudentCompletedStats.studentsCompletedCount"
                        class="delete-assignment__modal-text-1"
                    >
                        Your organization and the {{ assignmentStudentCompletedStats
                            .studentsNotCompletedCount }} students who
                        haven't completed the assignment yet will no longer have access once you delete.
                        {{ `${assignmentStudentCompletedStats.studentsCompletedCount > 1
                            ? `${assignmentStudentCompletedStats.studentsCompletedCount} students who have`
                            : 'One student who has'}` }}
                        already finished the assignment will still see it in their Study Activity.
                    </div>
                    <div v-else class="delete-assignment__modal-text-1">
                        Your entire organization will no longer have access once you delete.
                    </div>
                </div>
                <div class="delete-assignment__modal-buttons delete-assignment__modal-buttons--delete-modal">
                    <PocketButton
                        type="secondary"
                        @click="emit('close')"
                    >
                        Cancel
                    </PocketButton>
                    <PocketButton @click="emit('delete')">
                        Delete Assignment
                    </PocketButton>
                </div>
            </Modal>
        </ModalContainer>
    </Portal>
</template>

<style lang="scss" scoped>
@use 'sass:color';

.delete-assignment {

    &__modal {
        width: 374px;
        padding-bottom: 24px;
    }

    &__modal-container {
        padding: 36px 40px 0;
        text-align: center;
        margin-bottom: 32px;
    }

    &__modal-head {
        font-size: 18px;
        line-height: 25px;
        letter-spacing: 0.3px;
        font-weight: 600;
        margin-bottom: 12px;
    }

    &__modal-text-1, &__modal-text-2 {
        color: $ash;
        font-size: 15px;
        line-height: 20px;
    }

    &__modal-text-2 {
        margin-top: 20px;
    }

    &__modal-buttons {
        justify-content: space-between;
        display: flex;
        padding: 0 23.5px;

        &--delete-modal {
            margin: auto;
            width: 260px;
        }
    }
}
</style>
